@for (disposition of dispositions; track disposition; let i = $index) {
  <mat-card
    appearance="outlined"
    class="disposition mat-elevation-z6"
    >
    <disposition-form
      [disposition]="disposition"
    [readOnly]="
      !disposition.permission?._edit || disposition.is_final === true
    "></disposition-form>
    <div class="distributions">
      <div class="header">
        <span class="sub-title">Distributions</span>
        @if (!!disposition.permission?._edit && disposition.is_final !== true) {
          <button
            class="add-button"
            (click)="createDispositionDistribution(disposition.id)">
            <mat-icon>add</mat-icon>
          </button>
        }
      </div>
      @for (distribution of disposition.dispositionDistributions ?? []; track distribution) {
        <disposition-distribution
      [readOnly]="
        !disposition.permission?._edit || disposition.is_final === true
      "
          [distribution]="distribution"
          (distributionChanged)="distributionChanged($event)"
        [dispositionId]="disposition.id"></disposition-distribution>
      }
    </div>
  </mat-card>
}
